/**
 * Retorna a diferenca em dias entre a data passada por parametro e a data atual
 * @param value 2025-11-28 09:42:00-03
 * @returns number
 */
export function dateDiffDays({ value }: { value: string }): number {
    try {
        const hoje = new Date()
        const dataFim = new Date(value)

        const utcHoje = Date.UTC(hoje.getFullYear(), hoje.getMonth(), hoje.getDate())
        const utcDataFim = Date.UTC(dataFim.getFullYear(), dataFim.getMonth(), dataFim.getDate())

        return Math.floor((utcDataFim - utcHoje) / (1000 * 60 * 60 * 24))

    } catch (e: unknown) {
        console.error(e)
        return -1
    }
}